/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Google_One_Tap_EnabledInputs */

const en_admin_settings_fields_google_one_tap_enabled = /** @type {(inputs: Admin_Settings_Fields_Google_One_Tap_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Google One Tap`)
};

const zh_admin_settings_fields_google_one_tap_enabled = /** @type {(inputs: Admin_Settings_Fields_Google_One_Tap_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 Google One Tap`)
};

/**
* | output |
* | --- |
* | "Enable Google One Tap" |
*
* @param {Admin_Settings_Fields_Google_One_Tap_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_google_one_tap_enabled = /** @type {((inputs?: Admin_Settings_Fields_Google_One_Tap_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Google_One_Tap_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_google_one_tap_enabled(inputs)
	return zh_admin_settings_fields_google_one_tap_enabled(inputs)
});
export { admin_settings_fields_google_one_tap_enabled as "admin.settings.fields.google_one_tap_enabled" }